import { AxiosService } from './axios.service'

const baseURL = 'conversao-de-pontos'
/**
 * Defines the API methods for points conversion
 */
export default class PointsConversionService {
	/**
	 * Convertes the value into points
	 * @return {Promise<number>} The points
	 */
	static convertToPoints(value, busCompany) {
		const params = {
			value,
			busCompany
		}
		return AxiosService.get(`${baseURL}/converter-moeda`, {
			params
		}).then(({ data }) => data)
	}
}
